export default __webpack_public_path__ + "media/src/assets/images/year-revenue-b6c9014a240fe7b8cfa2cd76c3fda781.svg";